'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelCallbackHandler = function (_Component) {
  _inherits(PanelCallbackHandler, _Component);

  function PanelCallbackHandler() {
    _classCallCheck(this, PanelCallbackHandler);

    return _possibleConstructorReturn(this, (PanelCallbackHandler.__proto__ || Object.getPrototypeOf(PanelCallbackHandler)).apply(this, arguments));
  }

  _createClass(PanelCallbackHandler, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.context.setCanRefine) {
        this.context.setCanRefine(this.props.canRefine);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.context.setCanRefine && this.props.canRefine !== nextProps.canRefine) {
        this.context.setCanRefine(nextProps.canRefine);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return PanelCallbackHandler;
}(_react.Component);

PanelCallbackHandler.propTypes = {
  children: _propTypes2.default.node.isRequired,
  canRefine: _propTypes2.default.bool.isRequired
};
PanelCallbackHandler.contextTypes = {
  setCanRefine: _propTypes2.default.func
};
exports.default = PanelCallbackHandler;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/components/PanelCallbackHandler.js
// module id = 42
// module chunks = 142807904292071